/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SpinUpPreviewRequest
 */
export interface SpinUpPreviewRequest {
  /**
   *
   * @type {boolean}
   * @memberof SpinUpPreviewRequest
   */
  reboot: boolean;
}

/**
 * Check if a given object implements the SpinUpPreviewRequest interface.
 */
export function instanceOfSpinUpPreviewRequest(
  value: object,
): value is SpinUpPreviewRequest {
  if (!("reboot" in value) || value["reboot"] === undefined) return false;
  return true;
}

export function SpinUpPreviewRequestFromJSON(json: any): SpinUpPreviewRequest {
  return SpinUpPreviewRequestFromJSONTyped(json, false);
}

export function SpinUpPreviewRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SpinUpPreviewRequest {
  if (json == null) {
    return json;
  }
  return {
    reboot: json["reboot"],
  };
}

export function SpinUpPreviewRequestToJSON(json: any): SpinUpPreviewRequest {
  return SpinUpPreviewRequestToJSONTyped(json, false);
}

export function SpinUpPreviewRequestToJSONTyped(
  value?: SpinUpPreviewRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    reboot: value["reboot"],
  };
}
